import { kimlikUret } from "./kimlik";

export type GonderimKilidi = (is: (gecerli: () => boolean) => Promise<void>) => Promise<void>;

const KIRA_ANAHTARI = "ogrenci-senkron-kirasi";
const KIRA_SURESI = 15_000;
const SEKME_KIMLIGI = kimlikUret();
let sekmedeKilitli = false;

interface Kira {
  sahip: string;
  yenilendiAt: number;
}
function kirayiOku(): Kira | null {
  const ham = localStorage.getItem(KIRA_ANAHTARI);
  if (!ham) return null;
  try {
    const veri = JSON.parse(ham) as Kira;
    return typeof veri.sahip === "string" && Number.isFinite(veri.yenilendiAt) ? veri : null;
  } catch {
    return null;
  }
}

/**
 * F-STV-11 — 14.09.2026: Web Locks olmayan Safari'de gönderimi tamamen
 * kapatmak kayıtları cihazda biriktiriyordu. Aynı sekmede single-flight,
 * sekmeler arasında yenilenen kira kullanılır. Sekme ölürse 15 saniyede
 * devralınır; uyuyan eski sekme kira süresini kaçırınca yanıt uygulayamaz.
 * localStorage atomik CAS sunmaz: yazma sonrası yarışın durulması beklenir
 * ve sahip yeniden okunur; son tekillik güvencesi sunucunun kayıt kimliğidir.
 */
async function kirayla(is: Parameters<GonderimKilidi>[0]): Promise<void> {
  if (sekmedeKilitli) return;
  sekmedeKilitli = true;
  let yenileme: ReturnType<typeof setInterval> | undefined;
  let kaybedildi = false;
  const sahip = `${SEKME_KIMLIGI}:${kimlikUret()}`;
  const gecerli = () => {
    try {
      const kira = kirayiOku();
      return !kaybedildi && kira?.sahip === sahip && Date.now() - kira.yenilendiAt < KIRA_SURESI;
    } catch {
      return false;
    }
  };
  try {
    const onceki = kirayiOku();
    if (onceki && Date.now() - onceki.yenilendiAt < KIRA_SURESI) return;
    localStorage.setItem(KIRA_ANAHTARI, JSON.stringify({ sahip, yenilendiAt: Date.now() }));
    await new Promise((coz) => setTimeout(coz, 50));
    if (!gecerli()) return;
    yenileme = setInterval(() => {
      if (!gecerli()) {
        kaybedildi = true;
        return;
      }
      try {
        localStorage.setItem(KIRA_ANAHTARI, JSON.stringify({ sahip, yenilendiAt: Date.now() }));
      } catch {
        kaybedildi = true;
      }
    }, 5_000);
    await is(gecerli);
  } finally {
    if (yenileme) clearInterval(yenileme);
    try {
      if (kirayiOku()?.sahip === sahip) localStorage.removeItem(KIRA_ANAHTARI);
    } finally {
      sekmedeKilitli = false;
    }
  }
}

export const gonderimKilidiyle: GonderimKilidi = async (is) => {
  // F-STV-11 — kilitsiz kurtarma aktif başka sekmenin gönderimini tekrarlayabilir.
  if (typeof navigator === "undefined" || !navigator.locks) {
    await kirayla(is);
    return;
  }
  await navigator.locks.request(
    "ogrenci-senkron-gonderimi",
    { mode: "exclusive", ifAvailable: true },
    async (kilit) => {
      if (kilit) await is(() => true);
    },
  );
};
